module.exports = __webpack_public_path__ + "img/logo-tokyu.6902d2a5.png";